export const casinoGames = [
	{
		ext_id: 'treasure-seeker',
		name: 'Treasure Seeker',
		thumbnail_url: 'casino-games/animations/Pirates/pirate_game_thumbnail.avif',
		static_img: 'casino-games/animations/Pirates/static.avif',
		loss_to_loss: 'casino-games/animations/Pirates/loss-to-loss.avif',
		loss_to_win: 'casino-games/animations/Pirates/loss-to-win.avif',
		win_to_loss: 'casino-games/animations/Pirates/win-to-loss.avif',
		win_to_win: 'casino-games/animations/Pirates/win-to-win.avif',
		category: ['All'],
	},
	{
		ext_id: 'dragon-fortune',
		name: 'Dragon Fortune',
		thumbnail_url: 'casino-games/animations/China/china.avif',
		static_img: 'casino-games/animations/China/static-china.avif',
		loss_to_loss: 'casino-games/animations/China/loss-to-loss-China.avif',
		loss_to_win: 'casino-games/animations/China/loss-to-win-China.avif',
		win_to_loss: 'casino-games/animations/China/win-to-loss-China.avif',
		win_to_win: 'casino-games/animations/China/win-to-win-China.avif',
		category: ['All'],
	},
	{
		ext_id: 'ocean-riches',
		name: 'Ocean Riches',
		thumbnail_url: 'casino-games/animations/clam-game/clam_game_thumbnail.avif',
		static_img: 'casino-games/animations/clam-game/static.avif',
		loss_to_loss: 'casino-games/animations/clam-game/loss-to-loss.avif',
		loss_to_win: 'casino-games/animations/clam-game/loss-to-win.avif',
		win_to_loss: 'casino-games/animations/clam-game/win-to-loss.avif',
		win_to_win: 'casino-games/animations/clam-game/win-to-win.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'donut-delight',
		name: 'Donut Delight',
		thumbnail_url: 'casino-games/animations/Donuts/donuts_game_thumbnail.avif',
		static_img: 'casino-games/animations/Donuts/static-donuts.avif',
		loss_to_loss: 'casino-games/animations/Donuts/loss-to-loss-donuts.avif',
		loss_to_win: 'casino-games/animations/Donuts/loss-to-win-donuts.avif',
		win_to_loss: 'casino-games/animations/Donuts/win-to-loss-donuts.avif',
		win_to_win: 'casino-games/animations/Donuts/win-to-win-donuts.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'pharaohs-fortune',
		name: "Pharaoh's Fortune",
		thumbnail_url: 'casino-games/animations/Egypt/egypt.avif',
		static_img: 'casino-games/animations/Egypt/static-egypt.avif',
		loss_to_loss: 'casino-games/animations/Egypt/loss-to-loss-Egypt.avif',
		loss_to_win: 'casino-games/animations/Egypt/loss-to-win-Egypt.avif',
		win_to_loss: 'casino-games/animations/Egypt/win-to-loss-Egypt.avif',
		win_to_win: 'casino-games/animations/Egypt/win-to-win-Egypt.avif',
		category: ['All'],
	},
	{
		ext_id: 'mystic-woods',
		name: 'Mystic Woods',
		thumbnail_url: 'casino-games/animations/Forest/wild_game_thumbnail.avif',
		static_img: 'casino-games/animations/Forest/static-forest.avif',
		loss_to_loss: 'casino-games/animations/Forest/loss-to-loss-forest.avif',
		loss_to_win: 'casino-games/animations/Forest/loss-to-win-forest.avif',
		win_to_loss: 'casino-games/animations/Forest/win-to-loss-forest.avif',
		win_to_win: 'casino-games/animations/Forest/win-to-win-forest.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'olympian-riches',
		name: 'Olympian Riches',
		thumbnail_url: 'casino-games/animations/Greek/greek.avif',
		static_img: 'casino-games/animations/Greek/static-greek.avif',
		loss_to_loss: 'casino-games/animations/Greek/loss-to-loss-greek.avif',
		loss_to_win: 'casino-games/animations/Greek/loss-to-win-greek.avif',
		win_to_loss: 'casino-games/animations/Greek/win-to-loss-greek.avif',
		win_to_win: 'casino-games/animations/Greek/win-to-win-greek.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'mystic-spin',
		name: 'Mystic Spin',
		thumbnail_url: 'casino-games/animations/India/india.avif',
		static_img: 'casino-games/animations/India/static-india.avif',
		loss_to_loss: 'casino-games/animations/India/loss-to-loss-india.avif',
		loss_to_win: 'casino-games/animations/India/loss-to-win-india.avif',
		win_to_loss: 'casino-games/animations/India/win-to-loss-india.avif',
		win_to_win: 'casino-games/animations/India/win-to-win-india.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'love-spin',
		name: 'Love Spin',
		thumbnail_url: 'casino-games/animations/st-valentines/valentines.avif',
		static_img: 'casino-games/animations/st-valentines/static_Valentines.avif',
		loss_to_loss: 'casino-games/animations/st-valentines/loss-to-loss-Valentines.avif',
		loss_to_win: 'casino-games/animations/st-valentines/loss-to-win-Valentines.avif',
		win_to_loss: 'casino-games/animations/st-valentines/win-to-loss-Valentines.avif',
		win_to_win: 'casino-games/animations/st-valentines/win-to-win-Valentines.avif',
		category: ['All'],
	},
	{
		ext_id: 'luxe-spins',
		name: 'Luxe Spins',
		thumbnail_url: 'casino-games/animations/suits/suits_game_thumbnail.avif',
		static_img: 'casino-games/animations/suits/static-suits.avif',
		loss_to_loss: 'casino-games/animations/suits/loss-to-loss-suits.avif',
		loss_to_win: 'casino-games/animations/suits/loss-to-win-suits.avif',
		win_to_loss: 'casino-games/animations/suits/win-to-loss-suits.avif',
		win_to_win: 'casino-games/animations/suits/win-to-win-suits.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'viking-fortune',
		name: 'Viking Fortune',
		thumbnail_url: 'casino-games/animations/Viking/viking.avif',
		static_img: 'casino-games/animations/Viking/static-viking.avif',
		loss_to_loss: 'casino-games/animations/Viking/loss-to-loss-viking.avif',
		loss_to_win: 'casino-games/animations/Viking/loss-to-win-viking.avif',
		win_to_loss: 'casino-games/animations/Viking/win-to-loss-viking.avif',
		win_to_win: 'casino-games/animations/Viking/win-to-win-viking.avif',
		category: ['Top', 'All'],
	},
	{
		ext_id: 'witchs-spell',
		name: 'Witchs Spell',
		thumbnail_url: 'casino-games/animations/Witch/witch.avif',
		static_img: 'casino-games/animations/Witch/static-witch.avif',
		loss_to_loss: 'casino-games/animations/Witch/loss-to-loss-witch.avif',
		loss_to_win: 'casino-games/animations/Witch/loss-to-win-witch.avif',
		win_to_loss: 'casino-games/animations/Witch/win-to-loss-witch.avif',
		win_to_win: 'casino-games/animations/Witch/win-to-win-witch.avif',
		category: ['Top', 'All'],
	},
]
